import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Sidebar = ({ isOpen }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  const menuItems = [
    { icon: 'fas fa-home', text: 'Dashboard', path: '/dashboard' },
    { icon: 'fas fa-users', text: 'Patients', path: '/patients' },
    { icon: 'fas fa-user-md', text: 'Physicians', path: '/physicians' },
    { icon: 'fas fa-table', text: 'Tabular Data', path: '/tabular-data' },
    { icon: 'fas fa-pills', text: 'Medications', path: '/medications' },
    { icon: 'fas fa-folder', text: 'Surveys', path: '/surveys' },
    // { icon: 'fas fa-cog', text: 'Settings', path: '/settings' },
  ];

  const handleLogout = () => {
    // Add any logout logic here (e.g., clearing local storage, cookies, etc.)
    navigate('/login');
  };

  return (
    <div
      className={`fixed inset-y-0 left-0 z-30 w-64 bg-white shadow-lg transform ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } transition-transform duration-300 ease-in-out`}
    >
      <div className="flex flex-col h-full">
        {/* Logo */}
        <div className="flex items-center justify-center h-16 bg-white border-b border-gray-200">
          <span className="font-['Mulish'] text-primary text-2xl font-extrabold tracking-tight">
            Reg<span className="text-secondary">Medical</span>
          </span>
        </div>

        {/* Navigation Menu */}
        <nav className="flex-1 px-4 py-4">
          <ul className="space-y-2">
            {menuItems.map((item, index) => (
              <li key={index}>
                <button
                  onClick={() => navigate(item.path)}
                  className={`w-full flex items-center px-4 py-3 text-gray-700 rounded-lg hover:bg-gray-100 ${
                    location.pathname === item.path ? 'bg-primary text-white hover:bg-primary-dark' : ''
                  }`}
                >
                  <i className={`${item.icon} w-5`}></i>
                  <span className="ml-3">{item.text}</span>
                </button>
              </li>
            ))}
          </ul>
        </nav>

        {/* Logout Button */}
        <div className="p-4 border-t border-gray-200">
          <button
            onClick={handleLogout}
            className="w-full flex items-center px-4 py-3 text-gray-700 rounded-lg hover:bg-gray-100"
          >
            <i className="fas fa-sign-out-alt w-5"></i>
            <span className="ml-3">Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar; 